import React from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';

export default function SmartQuestionHeader(props) {
    const {type} = props;

    const classNames = R.cond([
        [R.isNil, R.always('smart-questions-header pending')],
        [R.equals(true), R.always('smart-questions-header success')],
        [R.equals(false), R.always('smart-questions-header failure')]
    ])(type);

    const text = R.cond([
        [R.isNil, R.always('Additional information required to determine campaign match.')],
        [R.equals(true), R.always('You are a potential match for this campaign.')],
        [R.equals(false), R.always('You are not a match for this campaign.')]
    ])(type);

    return (
        <div className={classNames}>
            <div id="smart-questions-header-text">{text}</div>
        </div>
    );
}

SmartQuestionHeader.propTypes = {type: PropTypes.string};



// WEBPACK FOOTER //
// ./components/campaign_guidelines/smart_question_header.js